import Vue from 'vue'
import vuex from 'vuex'

import app from './modules/app'
import tabs from './modules/tabs'
Vue.use(vuex)

const store = new vuex.Store({
  modules: {
    app,
    tabs
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js